<template>
  <div class="pill-list">
    <div
      v-for="(item, index) in items"
      :key="`${index}-${item.label}`"
      :title="item.label"
      :class="getItemClassName(item)"
      @click="() => action(item)"
    >
      <p class="pill-list-text">{{ item.label }}</p>
    </div>
  </div>
</template>

<script>
import classnames from "classnames";
export default {
  name: "list-component",
  props: {
    action: {
      type: Function,
    },
    items: {
      type: Array,
    },
    type: {
      type: String,
    },
  },
  methods: {
    getItemClassName(item) {
      const className = "pill-list-item";

      return classnames(className, {
        [this.type]: this.type,
        ["is-active"]: item.isActive,
      });
    },
  },
};
</script>
